import React,{useState,useEffect} from 'react';

const ImageTile=({surah,parentCompType})=>{
    return(
        <div>
            <a id={`surahLink-${surah.videoId}`} href={`/quran-videos/zamzam/play-video?vidId=${surah.videoId}`} className="blue-gr-box search grid grid-cols-1 alim-interactive-tile zamzam-tile w-full p-0">
                <div className="col-span-1 aspect-ratio-box">
                    <img src={surah.thumbnail.url} width="480" height="360" className="w-full h-full object-cover" loading="lazy"/>
                </div>
                <div className="col-span-1 flex justify-between p-3">
                    <div>
                        <p className="alim-text-color-style text-base">{surah.sname}</p>
                        <p className="text-sm text-deep-grey truncate">{surah.snameEng}</p>
                    </div>
                    {/* <div>
                        <p className="alim-text-color-style text-base text-center">{surah.surahNum}</p>
                        <p className="text-sm text-deep-grey truncate">{surah.ayahCount} Ayahs</p>
                    </div> */}
                </div>
            </a>
        </div>
    )
}

export default ImageTile;